import React from "react";

export default (props) => (
  <tr {...props} style={{ ...props.style }}>
    {props.children}
  </tr>
);
